import React from "react";
import {
  TrashIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  InformationCircleIcon,
  PencilSquareIcon,
} from "@heroicons/react/24/solid";

const BrandsRowDetails = ({
  details,
  onDelete,
  onEdit,
  onDown,
  onTop,
  selectedArea,
  selectedCategory,
  selectedSubCategory,
}) => {
  const values = [
    details.number,
    details.nameEN,
    details.nameAR,
    details.link,
    details.img,
    details.areaName,
    details.categoryName,
    details.subCategoryName,
  ];
  // console.log(details.maxLength)
  // console.log(details.index)
  return (
    <tr className="text-sm text-center text-gray-800 bg-white h-[60px]">
      {values.map((value, index) => (
        <td key={index} className="px-2 py-2">
          {index === 10 ? (
            <span title={value} className="text-black cursor-pointer">
              <InformationCircleIcon className="inline-block w-5 h-5 cursor-pointer text-custom-yellow" />
              Hover
            </span>
          ) : index === 4 ? (
            <img
              src={value}
              alt="Image"
              className="object-cover w-10 mx-auto"
            />
          ) : index === 3 ? (
            <span title={value} className="text-black cursor-pointer">
              <a
                href={value}
                className="px-2 py-1 text-black duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-100"
              >
                {values[1]}
              </a>
            </span>
          ) : (
            value
          )}
        </td>
      ))}
      <td className="px-2 py-2">
        <div className="flex justify-around gap-1">
          <button onClick={onDelete}>
            <TrashIcon className="w-5 h-5 text-red-600" />
          </button>
          <button onClick={onEdit}>
            <PencilSquareIcon className="w-5 h-5 text-black" />
          </button>
          {selectedArea && selectedCategory && selectedSubCategory && (
            <>
              {details.number !== details.maxLength ? (
                <button onClick={onDown}>
                  <ChevronDownIcon className="w-6 h-6 p-1 text-black bg-custom-yellow" />
                </button>
              ) : (
                <div className="w-6"></div>
              )}

              {details.number !== 1 ? (
                <button onClick={onTop}>
                  <ChevronUpIcon className="w-6 h-6 p-1 text-black bg-custom-yellow" />
                </button>
              ) : (
                <div className="w-6"></div>
              )}
            </>
          )}
        </div>
      </td>
    </tr>
  );
};

export default BrandsRowDetails;
